(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  if (!canHover.matches) return;

  function saveAndSwapImages(card, imageUrl) {
    if (!card || !imageUrl) return;

    const images = card.querySelectorAll('.product-media__image');

    images.forEach((img) => {
      if (!img.dataset.ascuaOriginalSrc) {
        img.dataset.ascuaOriginalSrc = img.getAttribute('src') || '';
        img.dataset.ascuaOriginalSrcset = img.getAttribute('srcset') || '';
        img.dataset.ascuaOriginalMaxResolution =
          img.getAttribute('data-max-resolution') || '';
      }

      img.src = imageUrl;
      img.srcset = imageUrl;

      if (img.hasAttribute('data-max-resolution')) {
        img.setAttribute('data-max-resolution', imageUrl);
      }
    });

    card.classList.add('ascua-color-preview-active');
  }

  function restoreImages(card) {
    if (!card) return;

    const images = card.querySelectorAll('.product-media__image');

    images.forEach((img) => {
      if (!img.dataset.ascuaOriginalSrc) return;

      img.src = img.dataset.ascuaOriginalSrc;

      if (img.dataset.ascuaOriginalSrcset) {
        img.srcset = img.dataset.ascuaOriginalSrcset;
      } else {
        img.removeAttribute('srcset');
      }

      if (img.dataset.ascuaOriginalMaxResolution) {
        img.setAttribute(
          'data-max-resolution',
          img.dataset.ascuaOriginalMaxResolution
        );
      }

      delete img.dataset.ascuaOriginalSrc;
      delete img.dataset.ascuaOriginalSrcset;
      delete img.dataset.ascuaOriginalMaxResolution;
    });

    card.classList.remove('ascua-color-preview-active');
  }

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest('.ascua-card-swatch');

    if (!swatch) return;

    if (swatch.contains(event.relatedTarget)) return;

    const imageUrl = swatch.dataset.imageUrl;
    const card = swatch.closest('product-card');

    if (!imageUrl || !card) return;

    restoreImages(card);
    saveAndSwapImages(card, imageUrl);
  });

  document.addEventListener('pointerout', (event) => {
    const swatch = event.target.closest('.ascua-card-swatch');

    if (!swatch) return;

    if (swatch.contains(event.relatedTarget)) return;

    const nextSwatch =
      event.relatedTarget?.closest?.('.ascua-card-swatch');

    if (nextSwatch && nextSwatch.closest('product-card') === swatch.closest('product-card')) {
      return;
    }

    const card = swatch.closest('product-card');

    restoreImages(card);
  });
})();

/* =========================================================
   ASCUA LAB - UN PRODUCTO VISUAL POR COLOR EN CATÁLOGO
   Mantiene una única ficha de Shopify y enlaza cada tarjeta
   a la variante de color correspondiente.
   ========================================================= */
(() => {
  const SELECTOR = '[data-ascua-variant-card="true"]';

  function setImage(img, url) {
    if (!img || !url) return;

    img.src = url;
    img.srcset = url;

    if (img.hasAttribute('data-max-resolution')) {
      img.setAttribute('data-max-resolution', url);
    }
  }

  function variantUrlFrom(baseHref, variantId) {
    try {
      const url = new URL(baseHref, window.location.origin);
      url.searchParams.set('variant', variantId);
      return url.pathname + url.search + url.hash;
    } catch {
      return baseHref;
    }
  }

  function initCard(item) {
    if (!item || item.dataset.ascuaInitialized === 'true') return;

    const variantId = (item.dataset.ascuaVariantId || '').replace('gid://shopify/ProductVariant/', '');
    const color = item.dataset.ascuaColor || '';
    const mainImage = item.dataset.ascuaMainImage || '';
    const hoverImage = item.dataset.ascuaHoverImage || '';
    const card = item.querySelector('product-card');

    if (!card || !variantId) return;

    const overlayLink = card.querySelector('.product-card__link');
    if (overlayLink) {
      overlayLink.href = variantUrlFrom(overlayLink.href, variantId);
      if (color) {
        const currentLabel = overlayLink.getAttribute('aria-label') || '';
        if (!currentLabel.endsWith(' · ' + color)) {
          overlayLink.setAttribute('aria-label', currentLabel + ' · ' + color);
        }
      }
    }

    // Any ordinary product links on the card should open this color.
    card.querySelectorAll('a[href*="/products/"]:not(.ascua-card-swatch)').forEach((link) => {
      link.href = variantUrlFrom(link.href, variantId);
    });

    // Make each catalogue card visibly distinguishable by color.
    const titleLink = card.querySelector('.text-block a');
    if (titleLink && color) {
      const baseTitle = titleLink.textContent.trim();
      if (baseTitle && !baseTitle.endsWith(' · ' + color)) {
        titleLink.textContent = baseTitle + ' · ' + color;
      }
    }

    const images = card.querySelectorAll('.product-media__image');
    if (images.length > 0 && mainImage) {
      setImage(images[0], mainImage);
    }
    if (images.length > 1 && hoverImage) {
      setImage(images[1], hoverImage);
    }

    // The existing swatches remain usable; highlight the color represented by this card.
    card.querySelectorAll('.ascua-card-swatch').forEach((swatch) => {
      const label = swatch.getAttribute('aria-label') || swatch.getAttribute('title') || '';
      swatch.classList.toggle('is-active', label === color);
    });

    item.dataset.ascuaInitialized = 'true';
  }

  function initAll(root = document) {
    if (root.matches?.(SELECTOR)) initCard(root);
    root.querySelectorAll?.(SELECTOR).forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  // Collection filtering and infinite scroll can inject new cards later.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) initAll(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
